export { DMS_MODULE } from '../constants';
export const NAME = 'WmsDashboard';
export const API_NAME = 'WmsDashboard';
export const CRUMB_LABEL_KEY = 'WmsDashboard';
